import React from 'react';
import { useLang } from './LanguageContext';
import t from './translations';

const Header = () => {
  const { lang, toggle } = useLang();
  const nav = t[lang].nav;

  return (
    <header>
      <div className="header-inner">
        <nav>
          <ul className="breadcrumbs">
            <li><a href="#home">{nav.home}</a></li>
            <li><a href="#about">{nav.about}</a></li>
            <li><a href="#skills">{nav.skills}</a></li>
            <li><a href="#work">{nav.work}</a></li>
            <li><a href="#projects">{nav.projects}</a></li>
            <li><a href="#contact">{nav.contact}</a></li>
          </ul>
        </nav>
        <button className="lang-toggle" onClick={toggle}>
          {lang === 'en' ? 'FR' : 'EN'}
        </button>
      </div>
    </header>
  );
};

export default Header;
